import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  bookCar,
  cleanBookingData,
  clearBookCarData,
  stripeSessionGet,
} from "../../redux/Slice/bookingSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import SuccessModal from "../RentYourCar/PaymentSuccessModal";
import { getUserDetail } from "../../redux/Slice/authSlice";
import noDataImg from "../../assets/no-data-found.png";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import { addCar, cleanAddCarData, cleanData, editCar } from "../../redux/Slice/formSlice";
const GpsPaymentVerify = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [addResp, setAddResp] = useState({});
  const {editCarID,carImagesResponse,PersonalDetails,driverDetails,carInsurance,carDetails,location} = useSelector((state) => state?.form);
  const gpsPayment = useSelector((state) => state?.auth?.gpsPayment);
  const [personalDetail, setPersonalDetail] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    identityFront: "",
    identityBack: "",
    userCountryCode: "",
    userPhoneNumber: "",
  });
  useEffect(() => {
    if (PersonalDetails) {
      setPersonalDetail({
        ...personalDetail,
        identityFront: PersonalDetails.identityFront
          ? PersonalDetails.identityFront
          : userDetail?.data?.identityFront,
        identityBack: PersonalDetails.identityBack
          ? PersonalDetails?.identityBack
          : userDetail?.data?.identityBack,
        // phone: userDetail?.data?.phoneNumber,
        phone:
         userDetail?.data?.country_code + userDetail?.data?.phoneNumber,
        userCountryCode: userDetail?.data?.country_code,
        userPhoneNumber: userDetail?.data?.phoneNumber,
        userId: userDetail?.data?._id,
        fullName: userDetail?.data?.name,
        email: userDetail?.data?.emailId,
        address: PersonalDetails?.address
          ? PersonalDetails?.address
          : userDetail?.data?.address,
      });
      
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PersonalDetails]);
  // useEffect(()=>{
  //   carCreateHandler();
  // },[personalDetail])
  // const [differenceInDays, setDifferenceInDays] = useState(null);
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const { loginId } = useSelector((state) => state?.auth);


  const [isPaid, setIsPaid] = useState(false);
  const [noData, setNoData] = useState(false);

  const { reference } = useParams(); // get the reference from URL params
  // const location = useLocation();
  const addCarData = useSelector((state) => state?.form?.addCarData);

 
  useEffect(() => {
    if (addCarData?.success === true) {
      toast(addCarData?.message);
      dispatch(cleanData());
      setTimeout(() => {
        navigate("/myvehicle");
      }, 3000);
    } else {
      if (!Array.isArray(addCarData)) {
        // toast("Something went wrong");
        dispatch(cleanAddCarData());
      }
    //   setTimeout(() => {
    //     setBtnStatus(false);
    //   }, 5000);
    }
    if (addCarData?.success === false) {
      toast(addCarData?.message);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addCarData]);
  useEffect(() => {
    if (addResp?.payload) {
      toast(addResp?.payload[0]);
    }
  }, [addResp]);
  
  useEffect(() => {
    async function verifyHandler() {
      const interval = setInterval(async () => {
        try {
          const verifyResponse = await axios.get(
            `https://api.lenco.co/access/v2/collections/status/${reference}`,
            {
              headers: {
                'Authorization': `Bearer ${process.env.REACT_APP_LENCO_SECRET_KEY}`, // Authorization header
              },
            }
          );
  
          if (verifyResponse?.data?.status && verifyResponse?.data.data.status !== "pending") {
            clearInterval(interval); // Stop the interval if status is not "pending"
            if (verifyResponse?.data.data.status === "successful") {
              carCreateHandler();
              
            } else {
              // Handle other statuses (if needed)
              console.log("Payment not successful, status:", verifyResponse?.data.data.status);
            }
          }
        } catch (error) {
          console.error("Error verifying status:", error);
          clearInterval(interval); // Stop the interval on error
        }
      }, 3000); // 3 seconds interval
  
      // Cleanup the interval if the component unmounts or reference changes
      return () => clearInterval(interval);
    }

    verifyHandler();
    // testing code
    // carCreateHandler();
  }, [reference]);
  
const carCreateHandler=async()=>{
  const formData = new FormData();
  const {
    carFrontImg,
    carBackImg,
    carLeftImg,
    carRightImg,
    carInteriorImg,
    carSeatsImg,
    carDashboardImg,
    carChassisImg,
    numberPlateImg,
    IDfront,
    IDback,
    licenceImg,
    diskImage,
  } = carImagesResponse;
 
  // Append personal details
  if (PersonalDetails) {
    formData.append("role", 1);
    // formData.append("name", PersonalDetails.fullName || "");
    // formData.append("UserEmail", PersonalDetails.email || "");
    // formData.append(
    //   "UserPhoneNumber",
    //   PersonalDetails.userPhoneNumber || ""
    // );
    // formData.append(
    //   "user_country_code",
    //   PersonalDetails.userCountryCode || ""
    // );
    // formData.append("userId", PersonalDetails.userId || "");
    formData.append("userId", userDetail?.data?._id);
    
    // formData.append("address", PersonalDetails.address || "");

    // As Readonly fields so no need to conver pass direct same url of image

    // if (editCarID) {
    //   formData.append("carId", editCarID);
    //   formData.append(
    //     "userIdentitycardFront",
    //     base64Data.identityFront || ""
    //   );
    //   formData.append(
    //     "userIdentitycardBack",
    //     base64Data.identityBack || ""
    //   );
    // } else {
    //   formData.append("identityFront", base64Data.identityFront || "");
    //   formData.append("identityBack", base64Data.identityBack || "");
    // }
    if (editCarID) {
        formData.append("carId", editCarID);
    }
    // formData.append("identityFront", personalDetail?.identityFront);
    // formData.append("identityBack", personalDetail?.identityBack);
  }

  // Append car details
  if (carDetails) {
    formData.append("maker", carDetails.carMake || "");
    formData.append("model", carDetails.carModel || "");
    formData.append("carCategory", carDetails.carType || "");
    formData.append("yearOfManufacture", carDetails.manufactureYr || "");
    formData.append("registrationNumber", carDetails.registrationNum || "");
    formData.append("numberOfSeats", carDetails.seat || "");
    formData.append("mileage", carDetails.mileage || "");
    formData.append("fuelType", carDetails.fuelType || "");
    formData.append("motor", carDetails.motor || "");
    formData.append("topSpeed", carDetails.speed || "");
    formData.append("power", carDetails.power || "");
    if (carDetails.carFeature) {
      carDetails.carFeature.forEach((feature) => {
        formData.append("features", feature);
      });
    } else {
      formData.append("features", "");
    }
    // formData.append("features", carDetails.carFeature || '');
    formData.append("carLocation", carDetails.carLocation || "");
    formData.append("lat", location?.lat || "");
    formData.append("long", location?.lng || "");
    // formData.append("frontImage", base64Data.carFrontImg || "");
    // formData.append("seat_image", base64Data.carSeatsImg || "");
    // formData.append("interior_image", base64Data.carInteriorImg || "");
    // formData.append("dashboard_image", base64Data.carDashboardImg || "");
    // formData.append("chasis_image", base64Data.carChassisImg || "");
    // formData.append("disk_image", base64Data.diskImage || "");
    // formData.append("backImage", base64Data.carBackImg || "");
    // formData.append("leftImage", base64Data.carLeftImg || "");
    // formData.append("rightImage", base64Data.carRightImg || "");
    // formData.append("numberPlateImage", base64Data.numberPlateImg || "");
    formData.append("frontImage", carFrontImg);
    formData.append("seat_image", carSeatsImg);
    formData.append("interior_image", carInteriorImg);
    formData.append("dashboard_image", carDashboardImg);
    formData.append("chasis_image", carChassisImg);
    formData.append("disk_image", diskImage);
    formData.append("backImage", carBackImg);
    formData.append("leftImage", carLeftImg);
    formData.append("rightImage", carRightImg);
    formData.append("numberPlateImage", numberPlateImg);
    formData.append("gpsAvaiblity", true);
    formData.append("withDriver", carDetails.driverToggle || false);
    formData.append("gpsPayment", gpsPayment?.data?.gpsPayment || 0);
  }
  // Append driver details
  // if (driverDetails) {
  //   formData.append("driverName", driverDetails.fullName || "");
  //   formData.append("driverAge", driverDetails.age || "");
  //   // formData.append("driverNumber", driverDetails.phone || "");
  //   formData.append("driverNumber", driverDetails.driverPhoneNumber || "");
  //   formData.append(
  //     "driver_country_code",
  //     driverDetails.driverCountryCode || ""
  //   );
  //   formData.append("driverEmail", driverDetails.email || "");
  //   formData.append("rent", driverDetails.driverRent || "");
  //   // formData.append("identityCardFrontSide", base64Data.IDfront || "");
  //   // formData.append("identityCardBackSide", base64Data.IDback || "");
  //   // formData.append("licenceCard", base64Data.licenceImg || "");
  //   // same sending image path for driver images
  //   formData.append("identityCardFrontSide", IDfront);
  //   formData.append("identityCardBackSide", IDback);
  //   formData.append("licenceCard", licenceImg);
  //   formData.append(
  //     "licenceIssueDate",
  //     driverDetails.licenceIssueDate || ""
  //   );
  //   formData.append(
  //     "licenceExpiryDate",
  //     driverDetails.licenceExpiryDate || ""
  //   );
  //   formData.append("withDriver", driverDetails.withDriver || false);
  // }

  // Append insurance details
  if (carInsurance) {
    formData.append("pricePerDay", carInsurance.pricePerDay || "");
    formData.append("companyName", carInsurance.companyName || "");
    formData.append("policyNumber", carInsurance.policyNumber || "");
    formData.append("expiryDate", carInsurance.expiryDate || "");
    formData.append(
      "insuranceAvailable",
      carInsurance.insuranceAvailable || false
    );
    if (editCarID) {
      dispatch(editCar({ data: formData })).then((res)=>{
        setAddResp(res);
      }).catch((error)=>{
        console.log(error)
      })
    } else {
      dispatch(addCar({ data: formData })).then((res) => {
        setAddResp(res);
      });
    }
  }
}

 
  

  return (
    <>
      {noData && !isPaid ? (
        <div className="container-fluid">
          <div className="row justify-content-center mt-5">
            <img
              className="col-lg-4 text-center  w-160 "
              src={noDataImg}
              alt="no data found"
            />
            <h4 className="text-center mt-5 accentColor">
              "No Data Found...."
            </h4>
          </div>
        </div>
      ) : (
        <>
          {isPaid ? (
            <div className="container-fluid">
              <SuccessModal />
            </div>
          ) : (
            <div className="container-fluid">
              <div className="row justify-content-center mt-5">
                {/* <img
                  className="col-lg-4 text-center  w-160 "
                  src={noDataImg}
                  alt="no data found"
                />
                <h4 className="text-center mt-5 accentColor">
                  "No Data Found...."
                </h4> */}
                <ClipLoader
                  color="#008080"
                  loading={!isPaid ? true : false}
                  // cssOverride={{ height: "30px" }}
                  size={80}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default GpsPaymentVerify;
